import {whitelabelling as Whitelabelling} from 'whitelabelling';

export function userInputCareerGoalsEmployers() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            displayType: '@?',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/directives/userInputs/userInputCareerGoalsEmployers.html',
        controller: [
            '$scope', 'RegistrationService', function($scope, RegistrationService) {
                $scope.showAddEmployer = false;
                $scope.whitelabelling = Whitelabelling;
                $scope.MAX_TO_ADD = 10;

                $scope.employersSelector = {
                    value: null,
                };

                $scope.employersHook = RegistrationService.employersPrefixComplete;

                $scope.removeEmployer = function(e) {
                    $scope.data.remove(e);
                };

                $scope.employersTipResource = function() {
                    return RegistrationService.getTopEmployers();
                };

                $scope.goToNextStep = function() {
                    $scope.$emit('goToNextStep');
                };

                $scope.$on('showErrors', function() {
                    $scope.noInputs = true;
                });

                // because we can add multiple concentrations, we have the intermediate value to store the
                // currently selecting one
                $scope.$watch('employersSelector.value', function(newVal) {
                    if (newVal) {
                        $scope.data.add(newVal);
                        $scope.noInputs = false;
                        $scope.employersSelector.value = '';
                        $scope.showAddEmployer = $scope.data.length < $scope.MAX_TO_ADD;
                    }
                });
            },
        ],
    };
}
